export default "__VITE_ASSET__DC0gj3n7__"